var map = {
	"./AlternateTopicMonitoring-icon.svg": 4419,
	"./BrandContent-icon.svg": 9583,
	"./ClientProfiles-icon.svg": 8935,
	"./PeopleAnalytics-icon.svg": 6208,
	"./ReputationManagement-icon.svg": 695,
	"./RivalAnalysis-icon.svg": 2177
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9915;